<template lang="pug">
  #sort-by
    #sort-header(@click="toggle")
      | {{ this.sortBy }}
      icon(data="~@/assets/svg/chevron-down.svg" width="16" height="16" :fill="false" color="#8B959B")

    #sort-menu(ref="menu" v-if="active" v-click-outside="toggle")
      .sm-title SORT BY
      .sm-action(v-for="option in sortOptions" @click="setSortBy(option)")
        | {{ option }}
</template>

<script>
import { createPopper } from '@popperjs/core'

export default {
  props: {
    placement: { type: String, required: false, default: 'bottom-start' },
    sortOptions: { type: Array, required: true },
  },

  data() {
    return {
      active: false,
      popper: null,
      sortBy: 'recent',
    }
  },

  computed: {},

  watch: {
    active: {
      async handler(value) {
        if (this.active) {
          await this.$nextTick()

          this.popper = createPopper(this.$el, this.$refs.menu, {
            placement: this.placement,
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 14],
                },
              },
            ],
          })
        } else {
          if (this.popper) {
            this.popper.destroy()
            this.popper = null
          }
        }
      },
    },
  },

  async mounted() {},

  methods: {
    setSortBy,
    toggle,
  },

  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
function setSortBy(option) {
  this.active = false
  this.sortBy = option
  this.$emit('sortBy', option)
}

function toggle() {
  this.active = !this.active
}
</script>
